<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "./info.vue";
import Repair from "./repair.vue";
import Track from "./track.vue";
import Change from "./change.vue";
import ImportTemplate from "@/views/components/common/form/workImportTemplate.vue";
import config from "@/../config";
import timeIcon from "../../assets/img/timeIcon.png";

export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    Change,
  },
  data() {
    return {
      table: {
        mname: "work",
        key: "id",
        makeMain: "",
        url: {
          list: "/admin/system/work/unfinishedCustomerList",
        },
        // synergy: "synergyState == 0? 是:否 ",
      },
      menus: [
      ],
      query: {
        state: 1,
      },
      actions: [
      ],
      filters: [
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "datetimerange",
        },
        {
          label: "所属医院",
          name: "customerId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "报修人电话",
          name: "repairPhone",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "报修人",
          KeyEnter: this.search,
          name: "repairBy",
          value: "",
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        {
          label: "处理人",
          KeyEnter: this.search,
          name: "maintainerName",
          value: "",
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "报修方式",
          name: "repairType",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "电话报修",
            },
            {
              value: 2,
              name: "扫码报修",
            },
            {
              value: 3,
              name: "移动报修",
            },
            {
              value: 4,
              name: "后台设备报修",
            },
            {
              value: 5,
              name: "后台科室报修",
            },
            {
              value: 6,
              name: "维修员",
            },
            {
              value: 7,
              name: "用户PC普通",
            },
            {
              value: 8,
              name: "用户PC快速",
            },
          ],
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "报修时间",
          width: 150,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "问题描述",
          key: "descr",
          minWidth: 350,
          align: "left",
          // tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            return h(
              "div",
              {
                style: `display: flex;
  align-items: center;`,
              },
              [
                h(
                  "div",
                  {
                    style:
                      this.workOrderTime(text, 1) > 30
                        ? `padding: 2px 5px;
    border-radius: 5px;
    margin-right: 5px;
    display: flex;
    align-items: center;
    background-color: #f6c6ad;
    color: #ff0000;
    `
                        : `padding: 2px 5px;
    border-radius: 5px;
    margin-right: 5px;
    display: flex;
    align-items: center;
    background-color: #c2f1c8;
    color: rgb(0 149 20);`,
                  },
                  [
                    h("img", {
                      style: `width: 20px;
    height: 20px;
    margin-right: 3px;`,
                      attrs: { src: timeIcon },
                    }),
                    h(
                      "div",
                      {
                        style: `height: 20px;
    line-height: 20px;
    white-space: nowrap;`,
                      },
                      this.workOrderTime(text, 2)
                    ),
                  ]
                ),
                h("div", { class: "descr_right" }, this.workOrderTime(text, 3)),
              ]
            );
          },
        },
        {
          title: "所在科室",
          key: "department",
          minWidth: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "所属医院",
          key: "customerName",
          width: 200,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修来源",
          key: "repairSource",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.repairSource === 1 && row.isFastOrder === 0
                ? "扫码报修"
                : row.repairSource === 1 && row.isFastOrder === 1
                ? "移动报修"
                : row.repairSource === 4
                ? row.repairPhone
                  ? row.repairPhone
                  : "电话报修"
                : row.repairSource === 5 && row.isFastOrder === 0
                ? "用户PC普通"
                : row.repairSource === 5 && row.isFastOrder === 1
                ? "用户PC快速"
                : row.repairSource === 3 && row.isFastOrder === 0
                ? "后台设备报修"
                : row.repairSource === 3 && row.isFastOrder === 1
                ? "后台科室报修"
                : row.repairSource === 2
                ? "维修员"
                : "";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "处理人",
          key: "maintainerName",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          fixed: "right",
          handle: [
            // (vm, h, currentRow, param) => {
            //   return (
            //     <Button
            //       size="small"
            //       type="default"
            //       onClick={() => this.onOrder(currentRow)}
            //       style={{
            //         border: "none",
            //         color: "#4991ff",
            //         marginLeft: "5px",
            //       }}
            //     >
            //       接单
            //     </Button>
            //   );
            // },
            // (vm, h, currentRow, param) => {
            //   // let directives = [];
            //   let directives = [{ name: "auth", value: "system/workOrder/change" }];
            //   const row = param.row;
            //   if (row.isSynergy == 0) {
            //     return (
            //       <Button
            //         {...{ directives }}
            //         size="small"
            //         onClick={() => this.toChange(currentRow)}
            //         type="default"
            //         style={{
            //           border: "none",
            //           color: "#4991ff",
            //           marginLeft: "5px",
            //           marginRight: "5px",
            //         }}
            //       >
            //         转单
            //       </Button>
            //     );
            //   }
            // },
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/workOrder/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  详情
                </Button>
              );
            },
            // "del",
          ],
        },
      ],
    };
  },
  created() {
    // this.loadLevelData();
    // this.loadLevelDatas();
    this.loaddeskData();
    this.loadCustomerList()
  },
  methods: {
    loadCustomerList(){
      let q ={}
      $utils.api.load('/admin/system/customer/list',q,'get').then(res=>{
        console.log(res);
        const list = res.rows.map((item) => {
              return {
                value: item.id,
                name: item.customerName,
              };
            });
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "customerId") {
                this.filters[index]["dropList"] = list;
              }
            }
      })
    },
    workOrderTime(e, type) {
      if (type == 1) {
        let timeA = Number(e.split("]")[0]);
        return timeA;
      } else if (type == 2) {
        let timeB = Number(e.split("]")[0]);
        let returnTime = "";
        if (timeB >= 60 * 24) {
          let d = parseInt(timeB / (60 * 24));
          let h = parseInt((timeB % (60 * 24)) / 60);
          let m = (timeB % (60 * 24)) % 60;
          returnTime = `${d}天${h}时${m}分`;
        } else if (60 * 24 >= timeB && timeB >= 60) {
          let ha = parseInt(timeB / 60);
          let ma = timeB % 60;
          returnTime = `${ha}时${ma}分`;
        } else {
          returnTime = `${timeB}分`;
        }
        return returnTime;
      } else if (type == 3) {
        let timeC = e.split("]")[1];
        return timeC;
      }
    },
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api.load(`/admin/system/desk/selectList`, q, "get").then((res) => {
            const list = res.rows.map((item) => {
              return {
                value: item.id,
                name: item.deskName,
              };
            });
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = list;
              }
            }
          });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load(`/admin/system/desk/selectList/?isParent=${"0"}`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "deskId") {
              this.filters[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "facilityNo") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    toflashAdd() {
      $utils.url.push({
        name: "workOrder_add",
        query: { action: "add", kv: "flash", msgkv: "flashadd" },
      });
    },
    toAdd() {
      $utils.url.push({
        name: "workOrder_add",
        query: { action: "add", msgkv: "add" },
      });
    },
    //转单
    toChange(row) {
      this.$Modal.success({
        closable: true,
        title: "转单",
        width: "1000px",
        // okButtonProps:{ style: { display: 'none' } },
        // footerHide: true,
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Change
              style={{ margin: "0", color: "#19be6b" }}
              id={row.id}
              typeId={row.typeId}
            ></Change>
          );
        },
      });
    },
    async handleChange(row) {
      let res = await $utils.api.load("/admin/system/work/startMaintain", row, "post");
      try {
        if (res && res.code == 200) {
          this.search();
        }
      } catch (e) {
        console.log(e);
      }
    },
    toRecycle() {
      $utils.url.push({
        name: "workOrder_recyle",
      });
    },
    // 接单
    async onOrder(id) {
      let res = await $utils.api.load(
        "/admin/system/work/startPCMaintain",
        { id: id.id },
        "post"
      );
      if (res.code == 200) {
        this.search();
        $utils.url.push({
          path: "processing_list",
          name: "processing_list",
        });
      }
    },
    //详情
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info_all",
        query: { action: "edit", kv: row.id, workId: row.id },
      });
    },

  },
};
</script>
<style scoped></style>
